module.exports = __webpack_public_path__ + "img/TW.e2d2694a.svg";